import {
    AffiliateNetworkService,
    WebsiteService,
    PerformanceService, TransactionService, AuthService
} from "@/main";
import notification from "@/mixins/notification";
import CurrentDate from "@/helpers/date";
import * as Sentry from "@sentry/browser";

export default {
    mixins: [notification],

    data() {
        return {
            extraFilter: {
                chosenAdvertiserNamesFilter: null,
                website: null
            }
        };
    },

    methods: {
        showCalendar() {
            this.$refs.calendar.showCalendar();
        },

        async getAffiliate() {
            try {
                this.Affiliate = await AffiliateNetworkService.getByStatusId(1);
            } catch (e) {
                console.log(e);
                Sentry.captureException(e);
                this.showNotification(
                    "warn",
                    "We have a problem",
                    "Oops! cant get affiliates"
                );
            }
        },

        async getWebsites() {
            try {
                this.websites = await WebsiteService.get();
            } catch (e) {
                console.log(e);
                Sentry.captureException(e);
                this.showNotification(
                    "warn",
                    "We have a problem",
                    "Oops! cant get websites"
                );
            }
        },

        async getPerformance(type, page, filter, reviewed = null) {
            try {
                if (filter) {
                    this.isLoading = true;
                }

                this.transactions = []

                const performance = await PerformanceService.get(
                    type,
                    CurrentDate.formatDate(this.dateRange.from),
                    CurrentDate.formatDate(this.dateRange.to),
                    page,
                    reviewed,
                    this.extraFilter
                );
                this.isPerformanceLoading = false;
                let performancesEntries = Object.entries(performance.data);
                this.Performances = performancesEntries.map(el => {
                    if (el[0] == "") {
                        el[0] = "(not set value)";
                    }
                    return this.getPerfomanceObject(el);
                });

                this.records = performance.total;

                if (filter) {
                    this.isLoading = false;
                }
            } catch (e) {
                console.log(e);
                Sentry.captureException(e);
                this.showNotification(
                    "warn",
                    "We have a problem",
                    "Oops! cant get performances"
                );
            }
        },

        async getAdvertiserTransactions(type, page, filter, reviewed) {
            try {
                if (filter) {
                    this.isLoading = true;
                }
                let params = {}

                if (reviewed) {
                    params.reviewedStartDate = this.dateRange.from
                    params.reviewedEndDate = this.dateRange.to
                } else {
                    params.startDate = this.dateRange.from
                    params.endDate = this.dateRange.to
                }
                params.websites = [this.extraFilter.website]
                params.program_name = this.extraFilter.chosenAdvertiserNamesFilter

                const transactionsData = await TransactionService.getFilteredTransactions(params, 1)

                this.transactions = transactionsData.transactions.data;
                if (filter) {
                    this.isLoading = false;
                }
            } catch (e) {
                console.log(e);
                Sentry.captureException(e);
                this.showNotification(
                    "warn",
                    "We have a problem",
                    "Oops! cant get performances"
                );
            }
        },

        async resetFilter(type) {
            this.setDateRange();
            // extra filter
            this.extraFilter.chosenAdvertiserNamesFilter = null;
            this.areAdvertiserTransactions = false;
            this.columns = this.columns.filter(el => el !== "showTransactions");
            this.transactions = []
            await this.getPerformance(type, 1);
        },

        getPerfomanceObject(perfomance) {
            return {
                name: perfomance[0],
                approvedNumber: Number(perfomance[1].approved.count),
                approved: Number(perfomance[1].approved.sum),
                pendingNumber: Number(perfomance[1].pending.count),
                open: Number(perfomance[1].pending.sum),
                disapprovedNumber: Number(perfomance[1].disapproved.count),
                disapproved: Number(perfomance[1].disapproved.sum),
                number: Number(perfomance[1].count),
                total: Number(perfomance[1].sum),
                approvalRate: Number(perfomance[1].approval_rate)
            };
        },

        setDateRange() {
            this.dateRange.from = CurrentDate.getCurrentMonthStart();
            this.dateRange.to = CurrentDate.getDateToday();
        },

        checkQueryParamsPresence(queryParams) {
            const queryParamsKeys = Object.keys(queryParams);
            const neededParams = [
                "date_end",
                "date_start",
                "performance_filter_name",
                "performance_type"
            ];
            return neededParams.every(el => queryParamsKeys.includes(el));
        },

        onExportPerformance(format) {
            const exportLink = PerformanceService.getExportLink(
                format,
                this.type,
                CurrentDate.formatDate(this.dateRange.from),
                CurrentDate.formatDate(this.dateRange.to),
                this.page,
                this.reviewed,
                this.extraFilter
            );

            window.open(exportLink + '&token=' + AuthService.getToken(), '_blank');
        },
    },



    created() {
        this.getAffiliate();
        this.getWebsites();
        this.setDateRange();
        if (!this.checkQueryParamsPresence(this.$route.query)) {
            this.getPerformance(this.type, this.page, false);
        }
    }
};
